import http from '@/core/http';
import { defineStore } from 'pinia';
import { IState } from './type';
import { userMe } from '@/api/uacs/user';
import { jumpSSOLogin } from '@/core/utils/sso';
import { currentEnv, SYSTEM_ENUM } from '@/core/http/env';
import { useAppStore } from '@/store/app';
import { TokenCookie } from '@toy/utils';

const tokenCookie = new TokenCookie(currentEnv);

const initToken = () => {
  const token = tokenCookie.getToken();
  if (token) {
    http.setHeader({
      Authorization: `Bearer ${token}`,
    });
  }
  return token || '';
};

export const useAccountStore = defineStore({
  id: 'account',
  state: (): IState => ({
    account: null,
    token: initToken(),
  }),
  // 定义修改state数据函数
  actions: {
    setToken(token: string) {
      this.token = token;
      tokenCookie.setToken(token);
      http.setHeader({
        Authorization: `Bearer ${token}`,
      });
    },
    // 获取用户信息
    async getAccountInfo() {
      try {
        if (this.account) return;
        const { data } = await userMe();
        this.account = data;
      } catch (e) {
        console.log(e);
        throw Error('获取用户信息失败');
      }
    },
    jumpSSO(logout: boolean = true) {
      const appStore = useAppStore();
      const ssoUrl = appStore.systemDomain ? appStore.systemDomain[SYSTEM_ENUM.LOGIN_WEB] : '';
      if (ssoUrl) {
        jumpSSOLogin(ssoUrl, logout);
      } else {
        window.location.reload();
      }
    },
    async logout() {
      this.clearCache();
      this.jumpSSO();
    },
    async login() {
      this.clearCache();
      this.jumpSSO(false);
    },
    // 清除所有缓存信息
    clearCache() {
      this.clearToken();
      this.account = null;
    },
    // 清除token
    clearToken() {
      this.token = null;
      http.setHeader({
        Authorization: '',
      });
    },
  },
});

http.setUnauthorizedCallback(async () => {
  await useAccountStore().login();
});
